import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Close menu when clicking outside
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!event.target.closest('.navbar') && isOpen) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);
    return () => document.removeEventListener('click', handleOutsideClick);
  }, [isOpen]);

  const handleNavigation = (e) => {
    e.preventDefault();
    setIsOpen(false);
    window.scrollTo(0, 0);
  };

  return (
    <header role="banner">
      <nav className="navbar" role="navigation" aria-label="Main navigation">
        <div className="container">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle"
              onClick={() => setIsOpen(!isOpen)}
              aria-expanded={isOpen}
              aria-controls="navbar-collapse"
              aria-label={isOpen ? "Close menu" : "Open menu"}
            >
              <i className={`fas ${isOpen ? 'fa-times' : 'fa-bars'}`} aria-hidden="true"></i>
            </button>
            <a 
              href="/"
              className="navbar-brand" 
              onClick={handleNavigation}
              aria-label="Home"
              style={{ textDecoration: 'none' }}
            >
              <img
                src="/assets/img/DA Logo w Icon.png"
                alt="DA Logo"
                className="logo"
                width="150"
                height="50"
              />
            </a>
          </div>
          <div
            id="navbar-collapse"
            className={`navbar-collapse ${isOpen ? 'show' : ''}`}
            role="menubar"
            aria-label="Main menu"
          >
            <ul className="nav navbar-nav navbar-right" role="menu">
              <li role="none">
                <a href="/" onClick={handleNavigation} role="menuitem">Home</a>
              </li>
              <li role="none">
                <a href="#about" onClick={() => setIsOpen(false)} role="menuitem">About</a>
              </li>
              <li role="none">
                <a href="#services" onClick={() => setIsOpen(false)} role="menuitem">Services</a>
              </li>
              <li role="none">
                <a href="#Workflow" onClick={() => setIsOpen(false)} role="menuitem">Workflow</a>
              </li>
              <li role="none">
                <a href="#contact" onClick={() => setIsOpen(false)} role="menuitem">Contact</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
